export const languageList = ['English', 'Mandarin', 'Malay', 'Hindi', 'Others'];
// export const yesNoValue = ['Yes', 'No'];
export const yesNoValue = [
    { value: 1, label: 'Yes' },
    { value: 0, label: 'No' }
];
// export const genders = ['male', 'female'];
export const genders = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
];

//export const relationships = ['Mother', 'Father', 'Son', 'Daughter', 'Others'];
export const relationships = [
    { value: 'mother', label: 'Mother' },
    { value: 'father', label: 'Father' },
    { value: 'son', label: 'Son' },
    { value: 'daughter', label: 'Daughter' },
    { value: 'others', label: 'Others' },
];

export const terms = ['1-month', '6-months', '12-months'];

//export const paymentTerms = ['Monthly', 'Quaterly', 'Half-Yearly', 'Yearly'];
export const paymentTerms = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'quaterly', label: 'Quaterly' },
    { value: 'half-yearly', label: 'half-yearly' },
    { value: 'yearly', label: 'Yearly' }
];

export const items = [
    {
        title: "First Section",
        inventories: [
            { title: "Wifi Modem", isCheckIn: 0, isCheckOut: 0 },
            { title: "Single Door Fridge (Electrolux)", isCheckIn: 0, isCheckOut: 0 }
        ]
    },
    {
        title: "Second Section",
        inventories: [
            { title: "Safety Locker", isCheckIn: 0, isCheckOut: 0 },
            { title: "Open Shelves", isCheckIn: 0, isCheckOut: 0 },
            { title: "Torch light", isCheckIn: 0, isCheckOut: 0 }
        ]
    },
    {
        title: "Third Section",
        inventories: [
            { title: "Soap Holder", isCheckIn: 0, isCheckOut: 0 },
            { title: "BICC Wall-mounted Hair Dryer", isCheckIn: 0, isCheckOut: 0 },
            { title: "Shower Head Set", isCheckIn: 0, isCheckOut: 0 },
            { title: "Toilet Paper Holder", isCheckIn: 0, isCheckOut: 0 },
            { title: "Towel Rack", isCheckIn: 0, isCheckOut: 0 },
            { title: "Mirror", isCheckIn: 0, isCheckOut: 0 },
            { title: "2 in 1 Dispenser", isCheckIn: 0, isCheckOut: 0 },
            { title: "Dustbin", isCheckIn: 0, isCheckOut: 0 },
            { title: "Bath Mat", isCheckIn: 0, isCheckOut: 0 },
            { title: "Bath Towel", isCheckIn: 0, isCheckOut: 0 }
        ]
    },
    {
        title: "Fourth Section",
        inventories: [
            { title: "Blackout Curtain", isCheckIn: 0, isCheckOut: 0 },
            { title: "Air Conditioning", isCheckIn: 0, isCheckOut: 0 },
            { title: "Bedside Table", isCheckIn: 0, isCheckOut: 0 },
            { title: "Pillow", isCheckIn: 0, isCheckOut: 0 },
            { title: "Bedsheet", isCheckIn: 0, isCheckOut: 0 },
            { title: "Duvet cover", isCheckIn: 0, isCheckOut: 0 },
            { title: "Medical Bed", isCheckIn: 0, isCheckOut: 0 },
            { title: "43 Inch LCD TV (LG)", isCheckIn: 0, isCheckOut: 0 },
            { title: "TV Remote Controller", isCheckIn: 0, isCheckOut: 0 },
            { title: "Chair", isCheckIn: 0, isCheckOut: 0 },
            { title: "Study Desk", isCheckIn: 0, isCheckOut: 0 }
        ]
    },
    {
        title: "Others",
        inventories: [

        ]
    }
];